export const ASSET_LIST = {
  SYMBOLS: {
    Symbol_1: '/assets/symbols-2/1.png?v=3',
    Symbol_2: '/assets/symbols-2/2.png?v=3',
    Symbol_3: '/assets/symbols-2/3.png?v=3',
    Symbol_4: '/assets/symbols-2/4.png?v=3',
    Symbol_5: '/assets/symbols-2/5.png?v=3',
    Symbol_6: '/assets/symbols-2/6.png?v=3',
    Symbol_7: '/assets/symbols-2/7.png?v=3',
    Symbol_8: '/assets/symbols-2/8.png?v=3',
    Wild: '/assets/symbols-2/wild.png',
    Scatter: '/assets/symbols-2/scatter.png'
  },
  
  // UI Images from ui-2 folder
  UI: {
    spinButton: '/assets/ui-2/spin-btn.png',
    plusButton: '/assets/ui-2/plus-btn.png',
    minusButton: '/assets/ui-2/minus-btn.png',
    infoButton: '/assets/ui-2/info-btn.png',
    menuButton: '/assets/ui-2/menu-btn.png',
    soundButton: '/assets/ui-2/sound-btn.png',
    autoSpinButton: '/assets/ui-2/auto-spin.png',
    frameBackground: '/assets/ui-2/bord-frame.png',
    gameBackground: '/assets/ui-2/game-bg.png'
  },
  
  AUDIO: {
    spin: '/assets/audio/spin.mp3',
    stop: '/assets/audio/stop.mp3',
    win: '/assets/audio/win.mp3',
    big_win: '/assets/audio/big_win.mp3',
    bonus: '/assets/audio/bonus.mp3',
    coin: '/assets/audio/coin.mp3'
  }
};

export function getSymbolAssets(): Record<string, string> {
  return ASSET_LIST.SYMBOLS;
}

export function getUIAssets(): Record<string, string> {
  return ASSET_LIST.UI;
}

export function getAllAssets(): string[] {
  const assets: string[] = [];
  
  Object.values(ASSET_LIST.SYMBOLS).forEach(path => assets.push(path));
  Object.values(ASSET_LIST.UI).forEach(path => assets.push(path));
  
  return assets;
}